<header [class.rtl]="currentLanguage === 'ar'">
  <div class="header-main">
    <div class="header-logo">
      <img src="../../../assets/images/renterz-logo.svg" alt="Renterz Logo" class="company-icon">
    </div>
    <!-- <div class="header-location">
    <div class="header-location-title">
      <img src="../../../assets/images/location-pin.svg" alt="location-icon" class="icon-location-pin">
      <span class="user-address-type">HOME</span>
    </div>
    <div class="user-location-container">
      <span>
        Nagar road, kalyani nagar, pune...
      </span>
      <img src="../../../assets/images/header-location-down-arrow.svg" alt="location selection arrow">
    </div>
  </div> -->
  </div>

  <div class="header-signup">
    <!-- <span class="text-not-account">Don't have an account?</span> -->
    <!-- <button type="button" class="button-back" (click)="logout()"><img src="../../../assets/images/orange-arrow.svg"
  alt="orange colored arrow"
style="margin-right: 5px;" /> Back to main website</button> -->

    @if (isMobile) {
    <!-- Mobile Hamburger Menu -->
    <button type="button" class="hamburger-menu" (click)="toggleSidebar()"
      [attr.aria-expanded]="sidebarMenuOpen"
      [attr.aria-label]="translationService.instant('header.openMenu', 'Open menu')">
      <span></span>
      <span></span>
      <span></span>
    </button>
    } @else {
    <!-- Desktop Menu -->
    @if (isLoggedIn) {
    <div class="mr-2">
      <button class="button-back" (click)="navigateHelp()" [title]="translationService.instant('header.help', 'Help')">
        <svg class="header-help-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
        <span>{{ translationService.instant('header.help', 'Help') }}</span>
      </button>
    </div>

    <div class="mr-2">
      <button class="button-back" (click)="navigateFaqs()" [title]="translationService.instant('header.faqs', 'FAQs')">
        <img class="mr-1 mb-1" src="../../../assets/icons/faqs.svg" alt="faqs-icon" />
        <span>{{ translationService.instant('header.faqs', 'FAQs') }}</span>
      </button>
    </div>

    <div class="custom-dropdown">
      <button class="button-back" (click)="toggleDropdown()">
        <img src="../../../assets/icons/sidebar/profile_active.svg" alt="user-icon" />
        {{ userName }}
      </button>
      <ul class="dropdown-menu" [ngClass]="{'dropdown-below': isOpen}">
        @for (option of dropdownOptions; track option) {
        <li (click)="selectOption(option.value)">
          <i [class]="option.value"></i>
          <span>{{ option.label }}</span>
        </li>
        }
      </ul>
    </div>
    }

    <!-- Language Dropdown (always visible on desktop) -->
    <div class="language-dropdown-wrapper">
      <button class="button-back language-button" (click)="toggleLanguageDropdown()" title="Change Language">
        <span class="language-flag">{{ currentLanguage === 'en' ? '🇺🇸' : '🇸🇦' }}</span>
        <span class="language-text">{{ getCurrentLanguageLabel() }}</span>
      </button>
      @if (isLanguageDropdownOpen) {
      <ul class="dropdown-menu language-menu" [ngClass]="{'dropdown-below': isLanguageDropdownOpen}">
        @for (option of languageOptions; track option.value) {
        <li (click)="selectLanguage(option.value)" [class.active]="currentLanguage === option.value">
          <span class="lang-flag">{{ option.flag }}</span>
          <span class="lang-label">{{ option.label }}</span>
        </li>
        }
      </ul>
      }
    </div>
    }

  </div>
</header>